import { style } from 'typestyle'
export const w57 = style({ width: '57%' })
